
{{#if items}}
<div class="row p-b-10">
    <div class="col-xs-12 col-sm-8">
        <h4 class="page-title">{{TR "Geräteberichte"}}</h4>
    </div>
    <div class="col-xs-12 col-sm-4">
        <div class="pull-right">
            <div class="btn-group pull-right">
                <a class="btn btn-default js-stats-add">
                    <i class="fa fa-plus"></i>
                </a>
                <a class="btn btn-default js-stats-refresh">
                    <i class="fa fa-refresh"></i>
                </a>
            </div>
        </div>
    </div>
</div>

<div id="js-table" class="row p-10"></div>
{{else}}
<div class="row">
	<div class="col-sm-12">
		<div class="card-box clearfix ">
			<h3 id="ct--heading">{{TR "Keine Geräteberichte vorhanden"}}</h3>
			<p>{{TR "Sie können einen Gerätebericht anlegen."}}</p>
		    <button id="ct-report-add" class="btn btn-primary js-report-device-add">
		        {{TR "Neuer Bericht"}}
		    </button>
		</div>
	</div>
</div>
{{/if}}
